module.exports = __webpack_public_path__ + "img/connection-small.809ee9f4.png";